import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import { ClarityService } from '@nomoh-monorepo/data-access-shared-analytics';
import { CookieConsentComponent } from '@nomoh-monorepo/data-access-shared-analytics';
import { ENVIRONMENT_TOKEN } from '@nomoh-monorepo/shared-data-access-environment';
import { TermoAceiteModalComponent } from '@nomoh-monorepo/shared-common-ui';

@Component({
  standalone: true,
  imports: [RouterModule, TranslateModule, ToastModule, CookieConsentComponent, TermoAceiteModalComponent],
  selector: 'app-root',
  template: `<p-toast position="top-center" [baseZIndex]="99999" [breakpoints]="{'920px':{width:'90vw'}}" showTransformOptions="translateY(-100%)" hideTransformOptions="translateY(-100%)" showTransitionOptions="300ms ease-out" hideTransitionOptions="200ms ease-in"></p-toast><lib-cookie-consent /><lib-termo-aceite-modal /><router-outlet></router-outlet>`,
})
export class AppComponent {
  constructor() {
    const env = inject(ENVIRONMENT_TOKEN);
    inject(ClarityService).init(
      env.analytics.clarityIds.nomohAdmin,
      env.analytics.clarityEnabled
    );
  }
}
